type FilterPillsProps = {
  label: string;
  options: string[];
  selected: string | null;
  onSelect: (option: string | null) => void;
  includeAllOption?: boolean;
};

export function FilterPills({ label, options, selected, onSelect, includeAllOption = true }: FilterPillsProps) {
  return (
    <section className="filter-group" aria-label={`${label} filter`}>
      <span className="filter-group__label">{label}</span>
      <div className="filter-group__options">
        {includeAllOption ? (
          <button className={selected === null ? "pill pill--active" : "pill"} type="button" onClick={() => onSelect(null)}>
            All
          </button>
        ) : null}
        {options.map((option) => (
          <button
            className={selected === option ? "pill pill--active" : "pill"}
            type="button"
            key={option}
            onClick={() => onSelect(option)}
          >
            {option}
          </button>
        ))}
      </div>
    </section>
  );
}
